import React, { useState, useEffect, FormEvent, ChangeEvent } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import moment from "moment";

import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import Grid2 from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import type { RootState } from "../../../../store";

import DateTimeField from "app/Components/Fields/DateTimeField";

import { getPlayerSessions } from "_DatabaseFunctions/directConnect/sessions";
import {
  setFilteredPlayerSessions,
  setPlayerSessions,
} from "../../../../store/actions";

import PlayerField from "./PlayerField";

interface PlayerSession {
  id: string;
  gameName: string;
  startTime: number;
  endTime?: number;
  hostId: string;
  playerId: string;
  [key: string]: any;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    textAlign: "center",
  },
  Paper: {
    margin: "30px 0px",
    padding: "24px",
    border: "1px solid black",
  },
  Grid: {
    margin: "auto",
  },
  Button: {
    width: "90%",
    color: "white",
    backgroundColor: "teal",
    padding: "12px",
    border: "none",
    cursor: "pointer",
  },
}));

const SearchOptions = () => {
  const location = useLocation();
  const classes = useStyles();
  console.log(location.pathname);

  const user = useSelector((state: RootState) => state.user.user);

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [isHost, setIsHost] = useState(false);

  const [startTime, setStartTime] = useState(
    `${moment().format("YYYY-MM-DD")}T00:00`,
  );

  const [endTime, setEndTime] = useState(
    `${moment().format("YYYY-MM-DD")}T23:59`,
  );

  useEffect(() => {
    if (location.pathname === "/hostSessions") {
      setIsHost(true);
    }
  }, [location]);

  const search = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setLoading(true);

    if (!user) {
      console.error("User not logged in");
      setLoading(false);
      return;
    }

    let hostId = null;
    let playerId = null;
    if (isHost) {
      hostId = user.uid;
    } else {
      playerId = user.uid;
    }

    const sessions = await getPlayerSessions({
      hostId,
      playerId,
      startTime: new Date(startTime).getTime(),
      endTime: new Date(endTime).getTime(),
    });

    dispatch(setPlayerSessions(sessions));

    let filteredSessions = sessions.sort((a: PlayerSession, b: PlayerSession) =>
      a.gameName.localeCompare(b.gameName),
    );
    filteredSessions = filteredSessions.sort(
      (a: PlayerSession, b: PlayerSession) => a.startTime - b.startTime,
    );
    dispatch(setFilteredPlayerSessions(filteredSessions));
    setLoading(false);
  };

  // todo: if is host render dropdown to search for player based on whitelist
  const renderPlayerListDropDown = () => {
    if (isHost) {
      return <PlayerField />;
    }
    return null;
  };

  return (
    <div>
      <Paper className={classes.Paper} elevation={12}>
        {/* {renderPlayerListDropDown()} */}
        <Grid2 container spacing={3}>
          <Grid2 size={{ xs: 12, sm: 12 }} className={classes.Grid}>
            <DateTimeField
              label="Start Time"
              value={startTime}
              onChange={(evt: ChangeEvent<HTMLInputElement>) =>
                setStartTime(evt.target.value)
              }
            />
            <DateTimeField
              label="End Time"
              value={endTime}
              onChange={(evt: ChangeEvent<HTMLInputElement>) =>
                setEndTime(evt.target.value)
              }
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12 }} className={classes.Grid}>
            {loading ? (
              <CircularProgress />
            ) : (
              <button className={classes.Button} onClick={search}>
                Search
              </button>
            )}
          </Grid2>
        </Grid2>
      </Paper>
    </div>
  );
};

export default SearchOptions;
